import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Box, Chip, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { ClientSessionsSummary } from "../clients/ClientSessionsSummary";
import { useClientSessionsSummary } from "../../api/client-sessions-summary";
import { differenceInYears } from "date-fns";
import { CallButton } from "../../components/phoneLetsCall/CallButton";
import { useIsScrolled } from "../../utils/useIsScrolled";
import { useIsMobile } from "../../utils/useIsMobile";

type TreatmentHeaderProps = {
	actions?: Actions;
};

export const TreatmentHeader = ({ actions }: TreatmentHeaderProps) => {
	const recordContext = useContext(RecordContext);

	const clientId = recordContext?.item?.client?.id;
	const treatmentId = recordContext?.item?.id;
	const { data: sessions, status } = useClientSessionsSummary(clientId, treatmentId);

	const clientAge = differenceInYears(new Date(), new Date(recordContext?.item?.client?.birthday));
	const clinicName = recordContext?.item?.client?.clinic_id.name;

	const isMobile = useIsMobile();
	const isScrolled = useIsScrolled({ isMobile: isMobile });

	if (!recordContext) return null;
	const { client } = recordContext.item;
	const clientName = `${client?.user_id?.first_name} ${client?.user_id?.last_name}`;

	const styles = componentStyles(isScrolled);

	return (
		<DetailHeader actions={actions} collection={recordContext.collection}>
			<Grid container sx={styles.container}>
				<Grid xs={12} sm={1} sx={styles.clientInfo} >
					<Box>
						<Typography variant="h6" color="secondary">
							Tratamento
						</Typography>
						<Box display="flex" alignItems="center" columnGap={2} flexWrap="wrap">
							<Typography variant="h5">{client?.client_id} </Typography>
							<Chip label={clinicName} size="small" sx={{ px: 1 }} />
						</Box>
					</Box>
					<Box>
						<Typography variant="body1">
							{clientName} ({clientAge} anos)
						</Typography>
						<CallButton phone={client?.user_id?.phone} chipPlacement="below" />
					</Box>
				</Grid>
					{!isScrolled && (
					<Grid xs={12} sm={11} sx={{ display: "flex" }}>
						<ClientSessionsSummary
							sessions={sessions}
							treatmentId={treatmentId}
							options={{ flexDirection: "row", presentation: "header" }}
							isLoading={status === "loading"}
						/>
					</Grid>
				)}
			</Grid>
		</DetailHeader>
	);
};

const componentStyles = (isScrolled: boolean) => {
	return {
		container: {
			display: "flex",
			alignItems: "flex-start",
			flexDirection: "row",
			flexWrap: { xs: "wrap", sm: "nowrap" },
			rowGap: 5,
			mb: { xs: 5, sm: 0 },
		},
		clientInfo: {
			minWidth: isScrolled ? 600 : 240,
			display: "flex",
			flexDirection: isScrolled ? "row" : "column",
			gap: isScrolled ? 10 : 0,
			alignItems: isScrolled ? "flex-end" : "flex-start",
		},
	};
};
